import React from 'react';
import { Form, Input, Button, Row } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import styles from './styles.less';

const FormItem = Form.Item;

const TWO_FA_TYPES = {
  CODE: 'CODE',
  RECOVERY_CODE: 'RECOVERY_CODE',
};

class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      enter2fa: false,
      twoFAUse: TWO_FA_TYPES.CODE,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.dispatch({
          type: 'login/login',
          payload: values,
        }).then((data) => {
          if (data && data.is2FAError) {
            this.setState({
              username: values.username,
              password: values.password,
              enter2fa: true,
            });
          }
        });
      }
    });
  };

  handleSubmit2fa = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const data = {
          username: this.state.username,
          password: this.state.password,
          code: '',
          recovery_code: '',
        };
        if (this.state.twoFAUse === TWO_FA_TYPES.CODE) {
          data.code = values.code;
        } else {
          data.recovery_code = values.code;
        }
        this.props.dispatch({
          type: 'login/login',
          payload: data,
        });
      }
    });
  };

  toForgotPassword(e) {
    e.preventDefault();
    this.props.dispatch({
      type: 'app/goToRoute',
      payload: { routeName: 'FORGOT_PASSWORD' },
    });
  }

  changeTwoFAUseType = () => {
    const type = this.state.twoFAUse === TWO_FA_TYPES.CODE ? TWO_FA_TYPES.RECOVERY_CODE : TWO_FA_TYPES.CODE;
    this.setState({ twoFAUse: type });
    this.props.form.setFieldsValue({ code: '' });
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    if (this.state.enter2fa) {
      const buttonTypeText = this.state.twoFAUse === TWO_FA_TYPES.CODE ? 'Components.LoginForm.UseRecoveryCode' : 'Components.LoginForm.UseCode';
      const inputText = this.state.twoFAUse === TWO_FA_TYPES.CODE ? 'Components.LoginForm.Code.Label' : 'Components.LoginForm.RecoveryCode.Label';

      return (
        <Form onSubmit={this.handleSubmit2fa} className={styles.loginForm}>
          <p className={styles.headerText}>
            <FormattedMessage id="Components.LoginForm.2FA.HeaderText" />
          </p>
          <FormItem>
            {getFieldDecorator('code', {
              rules: [{
                required: true,
                message: this.props.intl.formatMessage({ id: 'Common.Field.Required' }),
              }],
            })(
              <Input
                maxLength={255}
                placeholder={this.props.intl.formatMessage({ id: inputText })}
              />,
            )}
          </FormItem>
          <Row className={styles.loginFormButton}>
            <Button type="primary" htmlType="submit">
              Log in
            </Button>
          </Row>
          <Row className={styles.twoFATypeFormButton}>
            <Button type="default" onClick={this.changeTwoFAUseType.bind(this)}>
              <FormattedMessage id={buttonTypeText} />
            </Button>
          </Row>
        </Form>
      );
    }

    return (
      <Form onSubmit={this.handleSubmit} className={styles.loginForm}>
        <p className={styles.headerText}>
          <FormattedMessage id="Components.LoginForm.HeaderText" />
        </p>
        <FormItem>
          {getFieldDecorator('username', {
            rules: [{
              required: true,
              message: this.props.intl.formatMessage({ id: 'Components.LoginForm.Username.ErrorText' }),
            }],
          })(
            <Input
              maxLength={255}
              placeholder={this.props.intl.formatMessage({ id: 'Components.LoginForm.Username.Label' })}
            />,
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator('password', {
            rules: [{
              required: true,
              message: this.props.intl.formatMessage({ id: 'Components.LoginForm.Password.ErrorText' }),
            }],
          })(
            <Input
              maxLength={255}
              type="password"
              placeholder={this.props.intl.formatMessage({ id: 'Components.LoginForm.Password.Label' })}
            />,
          )}
        </FormItem>
        <Row className={styles.loginFormButton}>
          <Button type="primary" htmlType="submit">
            Log in
          </Button>
        </Row>
        <Row className={styles.loginFormForgot}>
          <a href="##" className={styles.btnNoBorder} onClick={this.toForgotPassword.bind(this)}>
            <FormattedMessage id="Components.LoginForm.ForgotPassword" />
          </a>
        </Row>
      </Form>
    );
  }
}

export default connect()(Form.create()(injectIntl(LoginForm)));



// WEBPACK FOOTER //
// ./src/components/LoginForm/LoginForm.js